<template>
  <div>
    <div class="form-group form-check">
      <label class="form-check-label" :for="id">
        <input
          :disabled="disabled"
          class="form-check-input"
          type="checkbox"
          :id="id"
          :checked="value"
          @change="update()"
          ref="input"
        />
        {{ text }}
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "volcan-input-checkbox",
  data: function () {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = "input" + this._uid;
  },
  props: {
    value: Boolean,
    text: String,
    disabled: Boolean,
  },
  methods: {
    update() {
      this.$emit("input", !this.value);
    },
  },
};
</script>
<style scoped>
.checkbox-indent {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/input-checkbox.vue